import React from 'react';
import { Loader2 } from 'lucide-react';
import { LoadingMark } from '@/components/ui/LoadingMark';
import { useLoadingPreset } from '@/hooks/shared/useOrgPreset';

interface AuthLoaderProps {
  message?: string;
}

export const AuthLoader: React.FC<AuthLoaderProps> = ({ 
  message = "Verificando autenticação..." 
}) => {
  // Org com marca própria: a marca dela flutuando no lugar do spinner (ver OrgPreset.loading).
  const brand = useLoadingPreset()?.loading;
  return (
    <div
      className="min-h-screen flex items-center justify-center bg-background"
      style={brand ? { backgroundColor: brand.background } : undefined}
    >
      <div className="flex flex-col items-center space-y-4">
        {brand ? (
          <LoadingMark sizeClassName="h-20 w-20" />
        ) : (
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
        )}
        <p className="text-sm text-muted-foreground" style={brand ? { color: brand.muted } : undefined}>
          {message}
        </p>
      </div>
    </div>
  );
};
